import { CLAIM_REWARD_SUCCESS, GET_REWARD_STATUS_SUCCESS } from "../types";

const initialState = () => ({
  rewardStatus: null,
  lastClaim: null,
});

const rewardReducer = (state = initialState(), { type, payload }) => {
  switch (type) {
    case CLAIM_REWARD_SUCCESS:
      return {
        ...state,
        lastClaim: {
          claimedAmount: payload.claimedAmount,
          newBalance: payload.newBalance,
          nextReceiveDate: payload.nextReceiveDate,
          timestamp: new Date().toISOString(),
        },
      };
    case GET_REWARD_STATUS_SUCCESS:
      return {
        ...state,
        rewardStatus: payload,
      };

    default:
      return state;
  }
};

export default rewardReducer;
